import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { EnableFor } from '../../../../../../../../__legacy__/containers/EnableForRole';
import { ToolTypeField } from '../../../commons/ui/fields/ToolTypeField';
import { IEditMarkingToolBl } from '../../EditMarkingTool.bl';
import { useEditMarkingToolPermissions } from '../../EditMarkingTool.permissions';
import { IEditMarkingToolStore } from '../../EditMarkingTool.store';

export const ToolTypeFieldContainer = observer((): ReactElement => {
  const bl = useInjection(IEditMarkingToolBl.$);
  const store = useInjection(IEditMarkingToolStore.$);
  const permissions = useEditMarkingToolPermissions();

  return (
    <EnableFor hasPermission={permissions.canChangeToolType()}>
      <ToolTypeField
        onChangeToolType={bl.changeToolType}
        toolType={store.toolType}
      />
    </EnableFor>
  );
});
